import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import { getFullCalendarConvertedDateFromDayJsDate } from 'src/supportPortal/components/common/roster/utils'

export const useRosterData = ({
  selectedItem,
  currentDate,
  toDate,
  getOptionValue,
  rosterListFetchApiSignature,
  bookedSlotsFetchApiSignature,
  rosterApiIdParamKey,
  bookedSlotsApiIdParamKey,
  bookedSlotsTransformer = (bookedSlots) => bookedSlots,
}) => {
  const [rosterList, setRosterList] = useState([])
  const [bookedSlots, setBookedSlots] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchRosterList = async () => {
    const itemId = getOptionValue(selectedItem)
    const resp = await getSPDataWithParams(rosterListFetchApiSignature, {
      fromDate: getFullCalendarConvertedDateFromDayJsDate(currentDate),
      toDate: getFullCalendarConvertedDateFromDayJsDate(toDate),
      [rosterApiIdParamKey]: itemId,
    })
    if (resp.status === 200) {
      setRosterList(resp?.data)
    }
  }

  const fetchBookedSlots = async () => {
    const itemId = getOptionValue(selectedItem)
    const startTime = dayjs(currentDate).startOf('day').toISOString()
    const endTime = dayjs(toDate).endOf('day').toISOString()

    const additionalParams = {}
    if (bookedSlotsApiIdParamKey) {
      additionalParams[bookedSlotsApiIdParamKey] = itemId
    }

    const resp = await getSPDataWithParams(bookedSlotsFetchApiSignature, {
      startTime,
      endTime,
      ...additionalParams,
    })
    if (resp.status === 200) {
      const bookedSlotsPeruser = resp?.data?.data?.bookedEvents || []
      const patients = resp?.data?.data?.patientInfo || []
      setBookedSlots(
        bookedSlotsPeruser
          ?.filter((event) => event?.status !== 'cancelled')
          ?.map((bInfo) => {
            const patInfo = patients?.find((pInfo) => pInfo?.id === bInfo?.patientId)
            return { ...bInfo, patientInfo: patInfo || null }
          }),
      )
    }
  }

  const refreshData = async () => {
    setLoading(true)
    if (selectedItem && getOptionValue(selectedItem)) {
      await Promise.all([fetchRosterList(), bookedSlotsFetchApiSignature && fetchBookedSlots()])
    }
    setLoading(false)
  }

  useEffect(() => {
    refreshData()
  }, [currentDate, toDate, selectedItem])

  return {
    rosterList,
    bookedSlots: bookedSlotsTransformer(bookedSlots),
    loading,
    setRosterList,
    refreshBookedSlots: fetchBookedSlots,
  }
}
